define([
	"dojo/_base/declare",
	"dijit/form/Form"
], function(declare,Form) {

	return declare(Form, {
		buildRendering: function() {
			// DOJO_INTERNAL - code from dijit._Templated
			// summary: Override base function to use srcNodeRef content as template -
			// this is needed so that Login/Password information is saved/restored by browser
			// because it will only do so for elements that are directly in page (not dynamically created)
			var	node = this.domNode = this.srcNodeRef;

 			// do string substitution - code to get all nodes taken from _attachTemplateNodes
			var nodes = node.all ? node.all : node.getElementsByTagName("*");
			var	a, n, i = 0;

			while (n = nodes[i++]) {
				if (n.attributes) {
					j = 0;

					while (a = n.attributes[j++]) {
						if (a.nodeValue && String(a.nodeValue).indexOf('$') >= 0) {
							n.setAttribute(a.nodeName, this._stringRepl(a.nodeValue));
						}
					}
				}

				if (n.firstChild && (n.firstChild == n.lastChild) && (n.firstChild.nodeType == 3)) {
					n.innerHTML = this._stringRepl(n.innerHTML);
				}
			}

			// _attachTemplateNodes will not apply AttachPoint/Event to root node, so do now
			this.containerNode = node;
			this.connect(node, "onsubmit", this.onSubmit);

 			// do regular business of attaching points and events
 			this._attachTemplateNodes(node, function(n,p){ return n.getAttribute(p); });

			// FIX? Missing _supportingWidgets for Login button since it will be parsed by document parse
		}
	});
});